import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private storageService: StorageService) { }

  login(email: string, password: string): Observable<any> {
    const payload = { username: email, password: password };

    return this.http.post<any>(`${environment.apiUrl}/auth/login`, payload);
  }

  logout(): void {
    this.storageService.logout();
  }

}